import React from "react";
import {
	useTable,
	useSortBy,
	useFilters,
	useExpanded,
	usePagination,
} from "react-table";
import {
	getCustomerSupportPreOpActiveListService,
	getCustomerSupportPreOpListService,
} from "../../services/java/java-services";
import {
	actions,
	salesRepMessages,
	errorMessages,
} from "../../helpers/messages";
import ErrorMsgBlockComponent from "../Error/ErrorMessageBlock";
import UpdateCSContainer from "../../containers/UpdateCustomerSupport/UpdateCSContainer";
import { isAuthenticated } from "../../helpers/GlobalFunctions";
import SubRowsReviewPlans from "../ReviewPlanList/SubRowsReviewPlans";
const showElementsArray = [10, 20, 30, 40, 50];

/** @description function to create UI for Data list
 *  @param  {}
 */
function Table({
	columns,
	data,
	fetchData,
	loading,
	pageCount: controlledPageCount,
	totalCount,
	listType,
	actionErrorObj,
	filterObj,
	searchString,
	reviewUpdated,
	successMsg,
	renderRowSubComponent,
	showPagination,
	errorObj,
	prevFilterObj
}) {
	// Use the state and functions returned from useTable to build your UI
	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		prepareRow,
		pageOptions,
		pageCount,
		page,
		state: { pageIndex, pageSize, sortBy },
		gotoPage,
		previousPage,
		nextPage,
		setPageSize,
		canPreviousPage,
		canNextPage,
		visibleColumns,
	} = useTable(
		{
			columns,
			data,
			initialState: { pageIndex: 0, sortBy: [], pageSize: 10 },
			manualPagination: true,
			autoResetPage: false,
			manualSortBy: true,
			disableFilters: false,
			disableSortBy: false,
			pageCount: controlledPageCount,
			totalCount: totalCount,
		},
		useFilters,
		useSortBy,
		useExpanded,
		usePagination
	);
	// Listen for changes in pagination and use the state to fetch our new data
	React.useEffect(() => {
		fetchData({ pageIndex, pageSize, sortBy });
		if (searchString || JSON.stringify(filterObj) !== JSON.stringify(prevFilterObj.current)) {
			gotoPage(0);
		  }		
		  prevFilterObj.current = filterObj;
		// eslint-disable-next-line
	}, [pageIndex, pageSize, sortBy, searchString, filterObj]);

	// message to show after update in the review pre plan table in salesrep panel
	/* istanbul ignore next  */
	let reviewSuccessMessage = "";
		/* istanbul ignore next  */
	if (reviewUpdated?.type === "hospitalId") {
		reviewSuccessMessage = salesRepMessages.hospitalUpdateMessage(
			reviewUpdated?.id,
			reviewUpdated?.selectedOptionText
		);
		/* istanbul ignore next  */
	} else if (reviewUpdated?.type === "salesRep") {
		reviewSuccessMessage = salesRepMessages.salesRepUpdateMessage(
			reviewUpdated?.id,
			reviewUpdated?.selectedOptionText
		);
	} else {
		reviewSuccessMessage = salesRepMessages.statusUpdateMessage(
			reviewUpdated?.id,
			reviewUpdated?.selectedOptionText
		);
	}

	/* istanbul ignore next  */
	if (reviewUpdated?.selectedOptionText === "Select Any Customer") {
		reviewSuccessMessage = salesRepMessages.unAssignMessage(reviewUpdated?.id);
	}

	/* istanbul ignore next  */
	return (
		<>
			{errorObj ? (
				<ErrorMsgBlockComponent errorObject={errorObj} />
			) : (
				<>
					{successMsg === "reviewsUpdate" ? (
						<div className="proms-success-msg">
							<p>Pre-op Plan {reviewSuccessMessage}</p>
						</div>
					) : null}

					{(data && data.length) || loading ? (
						<>
							{actionErrorObj ? (
								<ErrorMsgBlockComponent errorObject={actionErrorObj} />
							) : null}

							<div className="table-wrapper">
								<table
									role="table"
									{...getTableProps()}
									id={listType}
									className={
										listType
											? listType + " table-bordered table-hover"
											: "table-bordered table-hover w-100"
									}
								>
									<thead className="rt-thead">
										{headerGroups.map((headerGroup) => {
											let { key, ...restHeaderGroupProps } =
												headerGroup.getHeaderGroupProps();
											return (
												<tr key={key} {...restHeaderGroupProps}>
													{headerGroup.headers.map((column) => {
														let { key, ...restColumn } = column.getHeaderProps(
															column.getSortByToggleProps()
														);
														// Add the sorting props to control sorting. For this example
														// we can add them into the header props
														return (
															<th key={key} {...restColumn} title="">
																{column.render("Header")}
																{/* Add a sort direction indicator */}
																<span>
																	{column.isSorted ? (
																		column.isSortedDesc ? (
																			<svg className="bi bi-chevron-down" width="1.2em" height="1.2em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
																				<path fillRule="evenodd" d="M1.646 4.646a.5.5 0 01.708 0L8 10.293l5.646-5.647a.5.5 0 01.708.708l-6 6a.5.5 0 01-.708 0l-6-6a.5.5 0 010-.708z" clipRule="evenodd" />
																			</svg>
																		) : (
																			<svg className="bi bi-chevron-up" width="1.2em" height="1.2em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
																				<path fillRule="evenodd" d="M7.646 4.646a.5.5 0 01.708 0l6 6a.5.5 0 01-.708.708L8 5.707l-5.646 5.647a.5.5 0 01-.708-.708l6-6z" clipRule="evenodd" />
																			</svg>
																		)
																	) : (
																		""
																	)}
																</span>
																<div>
																	{column.canFilter ? column.render("Filter") : null}
																</div>
															</th>
														);
													})}
												</tr>
											);
										})}
									</thead>
									{loading ? (
										<tbody className="rt-tbody tr-refresh">
											{[...Array(10)].map((e, i) => (
												<tr key={i}>
													{[
														...Array(headerGroups && headerGroups.length ? headerGroups[0].headers.length : 1),
													].map((f, j) => (
														<td className="loading-cell" key={j}><span></span></td>
													))}
												</tr>
											))}
											<tr>
												<td colSpan="10000">{actions.load}</td>
											</tr>
										</tbody>
									) : (
										<tbody {...getTableBodyProps()} className="rt-tbody">
											{page.map((row, i) => {
												prepareRow(row);
												const {key, ...rowProps} = row.getRowProps();
												return (
													<React.Fragment key={key}>
														<tr {...rowProps}>
															{row.cells.map((cell) => {
																const {key, ...cellProps} = cell.getCellProps()
																return (
																	<td key={key} {...cellProps}>{cell.render("Cell")}</td>
																);
															})}
														</tr>
														{row.isExpanded &&
															renderRowSubComponent({
																row,
																rowProps,
																visibleColumns,
															})}
													</React.Fragment>
												);
											})}
											<tr className="result-count">
												<td colSpan="10000">Showing {page && page.length ? page.length : 0} of {totalCount} results</td>
											</tr>
										</tbody>
									)}
								</table>
								{totalCount > 0 && showPagination === true ? (
									<div className="pagination">
										<button className="me-1" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>{"<<"}</button>
										<button className="me-1" onClick={() => previousPage()} disabled={!canPreviousPage}>{"<"}</button>
										<button className="me-1" onClick={() => nextPage()} disabled={!canNextPage}>{">"}</button>
										<button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>{">>"}</button>
										
										<span className="page-display mx-2"> Page <strong> {pageIndex >= pageOptions.length ? pageOptions.length : pageIndex + 1} of {pageOptions.length} </strong></span>

										<select className="form-select res-dropdown" value={pageSize} onChange={(e) => { setPageSize(Number(e.target.value)); }}>
											{showElementsArray.map((rowsPerPage) => (
												<option key={rowsPerPage} value={rowsPerPage}>Show {rowsPerPage}</option>
											))}
										</select>
									</div>
								) : null}
							</div>
						</>
					) : (
						<ErrorMsgBlockComponent noData={true} />
					)}
				</>
			)}
		</>
	);
}

function ProOpPlansList(props) {
	let getColumnsFromProps = props.columns; // get columns and datalist type as props
	// eslint-disable-next-line
	let columnsList = [];
	// add the button based on the columns input
	getColumnsFromProps &&
		getColumnsFromProps.forEach((element) => {
			/* istanbul ignore next  */
			if (element.changeAssociationDropDown) {
				let hospitalAssociation = {
					Header: element.Header,
					Cell: ({ row }) => (
						<UpdateCSContainer
							salesRepList={props.salesRepUsersList}
							type={element.accessor}
							row={row.original}
							updateLoader={setLoading}
							updateError={reviewUpdateFailed}
							reviewDataUpdated={reviewDataUpdated}
						/>
					),
				};
				columnsList.push(hospitalAssociation);
			} else {
				columnsList.push(element);
			}
		});
	const columns = React.useMemo(() => columnsList, [columnsList]);
	const prevFilterObj = React.useRef(props.filterObj);
	// We'll start our table without any data
	const [preOpPlanList, setPreOpPlanList] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [totalCount, setTotalCount] = React.useState(0);
	const [pageCount, setPageCount] = React.useState(0);
	const fetchIdRef = React.useRef(0);
	const [errorObj, setErrorObj] = React.useState(null);
	const [actionErrorObj, setActionErrorObj] = React.useState(null);
	const [successMsg, setSuccessMsg] = React.useState("");
	const [reviewUpdated, setReviewUpdated] = React.useState(null);
	const [pageSize, setPageSize] = React.useState(10);
	const [currentPage, setCurrentPage] = React.useState(0);
	/**
	 * @description Handle the error response by setting the error state and loading state
	 * @param error Error object
	 */
	/* istanbul ignore next */
	const handleError = (error) => {
		setErrorObj(error);
		setLoading(false);
	};

	/**
	 * @description Function to get mapped surgeon list for RAR
	 * @param  { }
	 */
	/* istanbul ignore next  */
	const getCustomerSupportPlanList = (planParams) => {
		let urlParams = {
			page: planParams.pageIndex + 1,
			limit: planParams.pageSize || 10,
			sortOrder: planParams.sortOrder || "desc",
			columnName: planParams.columnSortBy || "plan_creation_date,surgery_date",
			procedureStatus: props.filterObj.status || 1, // only available plans to show default load
		};
		if (props.filterObj.procedureType !== 'all') {
			urlParams["procedureName"] = props.filterObj.procedureType;
		}
		if (planParams.props.showFilterBlock) {
			urlParams["procedureName"] = props.filterObj.procedureType;
			urlParams["customerid"] = props.filterObj.customer;
			urlParams["procedureStatus"] = props.filterObj.status;
			urlParams["salesrepName"] = props.filterObj.salesRep;
			urlParams["searchString"] = props.filterObj.searchString;
		}
		if (urlParams["procedureStatus"] === "all") {
				urlParams["showallstatus"] = true;
		}

		for (let key in urlParams) {
			if (urlParams[key] === "all" || urlParams[key] === "") {
					delete urlParams[key];
			}
		}
		setLoading(true);
		// only get the data for active plans
		if (planParams.props.isActiveListOnly) {
			// authentication checked here we are getting error on logout with these API call
			isAuthenticated() &&
				getCustomerSupportPreOpActiveListService(urlParams, (err, result) => {
					handleApiResponse(err, result, planParams);
				});
		} else {
			isAuthenticated() &&
				getCustomerSupportPreOpListService(urlParams, (err, result) => {
					handleApiResponse(err, result, planParams);
				});
		}
	};

	/**
	 * @description Populate the data and related states
	 * @param newData Array of data
	 * @param newPageCount Total number of pages
	 * @param newTotalCount Total count of items
	 * @param newError Error object
	 */
	/* istanbul ignore next */
	const populateData = (newData, newPageCount, newTotalCount, newError) => {
		setPreOpPlanList(newData);
		setPageCount(newPageCount);
		setTotalCount(newTotalCount);
		setErrorObj(newError);
		setLoading(false);
	};

	/**
	 * @description Handle the success response by populating data and related states
	 * @param data Array of data
	 * @param totalCount Total count of items
	 * @param allParams pagination params
	 */
	/* istanbul ignore next */
	const handleSuccess = (resData, totalResCount, allParams) => {
		const getMetadata = resData ? resData : [];
		const pageResCount = Math.ceil(totalResCount / (allParams.pageSize || 10));
		setPageSize(allParams.pageSize || 10);
		setCurrentPage(allParams.pageIndex);
		populateData(getMetadata, pageResCount, totalResCount, null);
	};

	/* istanbul ignore next */
	/**
	 * @description reuseable function for the handling response
	 * @param {*} err : Error obj
	 * @param {*} result :Obj containing result
	 * @param {*} params : params to get user's data like pagination
	 */
	const handleApiResponse = (err, result, resParams) => {
		/* istanbul ignore next */
		if (err) {
			if (err.errorCode === 5022) {
				handleError(new Error(errorMessages.salesrep.noResult));
			} else {
				handleError(err);
			}
		} else {
			const {
				PreopPlanCaseResponse,
				response_metadata: { total },
			} = Array.isArray(result.data) ? result.data[0] : result.data;

			handleSuccess(PreopPlanCaseResponse, total, resParams);
		}
	};

	/**
	 * @description Function to show salesrep review pre plan update change failed
	 * @param  {}
	 */
	/* istanbul ignore next  */
	const reviewUpdateFailed = (error) => {
		setSuccessMsg("");
		setActionErrorObj(error);
	};

	/**
	 * @description Function to show salesrep review pre plan update change succeeded
	 * @param  row: infomation about the row that is being updated
	 */
	/* istanbul ignore next  */
	const reviewDataUpdated = (row) => {
		setActionErrorObj(null);
		setSuccessMsg("reviewsUpdate");
		setReviewUpdated(row);
		setTimeout(() => {
			setSuccessMsg("");
		}, 10000);
		if (row.type === "salesRep" || row.type === "hospitalId") {
			getCustomerSupportPlanList({
				pageIndex: currentPage,
				props: {},
				pageSize
			});
		}
	};
	const fetchData = React.useCallback(
		({ pageSize, pageIndex, sortBy }) => {
			let columnSortBy = "";
			let sortOrder = "";
			let keyMapping = {};
			/* istanbul ignore next  */
			if (sortBy[0]) {
				columnSortBy = Object.keys(keyMapping).length
					? keyMapping[sortBy[0].id]
					: sortBy[0].id;
				sortOrder = sortBy[0].desc ? "desc" : "asc";
			}
			const fetchId = ++fetchIdRef.current;

		/* istanbul ignore next  */			
			if (fetchId === fetchIdRef.current) {
				if (props.listType === "customer-support-preoplist") {
					getCustomerSupportPlanList({
						pageIndex,
						pageSize,
						columnSortBy,
						sortOrder,
						props,
					});
				}
			}
		},
		// eslint-disable-next-line
		[props]
	);

	// Create a function that will render our row sub components
	/* istanbul ignore next  */
	// eslint-disable-next-line
	const renderRowSubComponent = React.useCallback(
		({ row, rowProps, visibleColumns }) => (
			<>
				{row?.original?.patientDetails ? (
					<SubRowsReviewPlans
						row={row}
						rowProps={rowProps}
						visibleColumns={visibleColumns}
						type={props?.listType}
					/>
				) : (
					<> </>
				)}
			</>
		),
		// eslint-disable-next-line
		[props]
	);

	/**
     * @description function to handle customer support list based on prop isUpdated if isUpdated is true it will fetch the data API
     */
  /* istanbul ignore next  */
  // eslint-disable-next-line
  React.useMemo(()=>{
    if(props.isUpdated) {
      getCustomerSupportPlanList({
        pageIndex: 0,
        props: {},
        pageSize
      });
    }
      // eslint-disable-next-line
  },[props]);

  return (
    <Table
      columns={columns}
      data={preOpPlanList}
      fetchData={fetchData}
      listType={props.listType}
      pageCount={pageCount}
      totalCount={totalCount}
      showPagination={true}
      filterObj={props.filterObj}
      searchString={props.searchString}
      isActiveListOnly={props.isActiveListOnly}
      showFilterBlock={props.showFilterBlock}
      salesRepUsersList={props.salesRepList}
      actionErrorObj={actionErrorObj}
      errorObj={errorObj}
      successMsg={successMsg}
      loading={loading}
      reviewUpdated={reviewUpdated}
      renderRowSubComponent={renderRowSubComponent}
	  prevFilterObj={prevFilterObj}
    />
  );
}
export { ProOpPlansList, Table };